import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Navigation as NavigationStyled, NavigationElement } from "../ui";
import styled from "styled-components";
import noiseImage from './noise.svg'

const Container = styled.div`
    position: relative;
    z-index: 6;
    padding: 5rem 2rem 5rem 5rem;
    box-sizing: border-box;

    @media screen and (max-width: 1260px) {
        margin-right: 0rem;
        width: 100%;
        padding: 4rem 4rem 1rem;
    }

    @media screen and (max-width: 920px) {
        padding: 3rem 3rem 1rem;
    }

    @media screen and (max-width: 740px) {
        padding: 2rem 2rem  1rem;
    }
  
    @media screen and (max-width: 390px) {
        padding: 2rem 2rem 0rem;
    }
`

const MobileNavigation = styled.div`
    display: none;
    position: fixed;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    box-sizing: border-box;
    z-index: 20;
    right: 0;
    top: 0;
    width: 20rem;
    max-width: 100vw;
    bottom: 0;
    padding: 2rem;
    background-image:
            radial-gradient(farthest-corner at -16px 30px, #ffad3d87, #a5550a00),
            radial-gradient(farthest-corner at 48px 30px, #e5d115, #a5550a00),
            linear-gradient(70deg, #e5c021, #e6a505 76%),
            url(${noiseImage});

    @media screen and (max-width: 920px) {
        display: flex;
    }

    @media screen and (max-width: 500px) {
        width: 100vw;
    }

    & ul {
        display: flex;
        flex-direction: column;
    }
`

const Navigation: React.FC = () => {
    const location = useLocation()
    const [showMobileNavigation, setShowMobileNavigation] = useState<boolean>(false)

    useEffect(() => {
        close()
    }, [location])

    useEffect(() => {
        const resizeHandler = () => {
            close()
        }
        window.addEventListener('resize', resizeHandler);

        return () => {
            window.removeEventListener('resize', resizeHandler);
        }
    })

    const open = () => {
        setShowMobileNavigation(true)
    }
    const close = () => {
        setShowMobileNavigation(false)
    }

    return (
        <>
            {showMobileNavigation && <MobileNavigation>
                <NavigationStyled $responsive={false}>
                    <NavigationElement $active={location.pathname === '/contact'} $responsive={false}>
                        <a href="#" style={{ textAlign: 'right', display: 'block', fontSize: '1.5rem' }} onClick={close}>
                            Close
                            <svg style={{ margin: '-.6em 0'}} width="2em" height="2em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="close">
                                <g>
                                    <path d="m13.41 12 4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29-4.3 4.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4.29-4.3 4.29 4.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42z"></path>
                                </g>
                            </svg>
                        </a>
                    </NavigationElement>
                    <NavigationElement $active={location.pathname === '/'} $responsive={false}>
                        <Link to="/">Home</Link>
                    </NavigationElement>
                    <NavigationElement $active={location.pathname === '/cv'} $responsive={false}>
                        <Link to="/cv">/Cv</Link>
                    </NavigationElement>
                    <NavigationElement $active={location.pathname === '/contact'} $responsive={false}>
                        <Link to="/contact">/Contact</Link>
                    </NavigationElement>
                </NavigationStyled>
                <NavigationStyled  $list>
                    <NavigationElement $active={location.pathname === '/game/_breakout'} $responsive={false}>
                        <Link to="/game/_breakout">/_Game</Link>
                    </NavigationElement>
                    <NavigationElement $active={location.pathname === '/_music'} $responsive={false}>
                        <Link to="/_music">/_Music</Link>
                    </NavigationElement>
                    <NavigationElement $active={location.pathname === '/_imprint'} $responsive={false}>
                        <Link to="/_imprint">/_Imprint</Link>
                    </NavigationElement>
                </NavigationStyled>
            </MobileNavigation>}
            <Container>
                <NavigationStyled>
                    <NavigationElement>
                        <h2>{'>'}Alexander<br />Mührenberg</h2>
                        <h3>Software Engineer</h3>
                    </NavigationElement>
                    <NavigationElement $active={location.pathname === '/'} $showMobile={false}>
                        <Link to="/">Home</Link>
                    </NavigationElement>
                    <NavigationElement $active={location.pathname === '/cv'} $showMobile={false}>
                        <Link to="/cv">/Cv</Link>
                    </NavigationElement>
                    <NavigationElement $active={location.pathname === '/contact'} $showMobile={false}>
                        <Link to="/contact">/Contact</Link>
                    </NavigationElement>
                    <NavigationElement $active={location.pathname === '/contact'} $showMobile={true} $showDesktop={false}>
                        <a href="#" style={{ padding: '0.5rem' }} onClick={(event) => {event.preventDefault(); open()}}>
                            <svg width="1.8em" height="1.8em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                                <title>70 Basic icons by Xicons.co</title>
                                <path d="M41,14H7a2,2,0,0,1,0-4H41A2,2,0,0,1,41,14Z" />
                                <path d="M41,26H7a2,2,0,0,1,0-4H41A2,2,0,0,1,41,26Z" />
                                <path d="M41,38H7a2,2,0,0,1,0-4H41A2,2,0,0,1,41,38Z" />
                            </svg>
                        </a>
                    </NavigationElement>
                </NavigationStyled>
                <NavigationStyled>
                    <NavigationElement $active={location.pathname === '/game/_breakout'} $showMobile={false}>
                        <Link to="/game/_breakout">/_Game</Link>
                    </NavigationElement>
                    <NavigationElement $active={location.pathname === '/_music'} $showMobile={false}>
                        <Link to="/_music">/_Music</Link>
                    </NavigationElement>
                    <NavigationElement $active={location.pathname === '/_imprint'} $showMobile={false}>
                        <Link to="/_imprint">/_Imprint</Link>
                    </NavigationElement>
                </NavigationStyled>
            </Container>
        </>
    )
}

export default Navigation